import React from 'react';
import TableSkeleton from '../common/TableSkeleton';

/**
 * PaymentAnalyticsSkeleton
 * Placeholder for the Payment Analytics tab while initial data loads.
 * Mirrors the tab's layout: 4 KPI tiles, trend block, breakdown block, projects table.
 */
export default function PaymentAnalyticsSkeleton() {
  return (
    <div className="p-4 md:p-6 space-y-6 animate-pulse">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
        <div className="space-y-2">
          <div className="h-6 w-48 bg-gray-200 rounded" />
          <div className="h-3 w-72 bg-gray-100 rounded" />
        </div>
        <div className="flex gap-2">
          <div className="h-9 w-32 bg-gray-200 rounded-md" />
          <div className="h-9 w-28 bg-gray-200 rounded-md" />
        </div>
      </div>

      {/* KPI Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {Array(4).fill(0).map((_, i) => (
          <div key={i} className="bg-white rounded-lg shadow p-5 border border-gray-200">
            <div className="h-3 w-24 bg-gray-200 rounded" />
            <div className="mt-3 h-7 w-32 bg-gray-300 rounded" />
            <div className="mt-2 h-3 w-40 bg-gray-100 rounded" />
          </div>
        ))}
      </div>

      {/* Trend chart */}
      <div className="bg-white rounded-lg shadow p-5 border border-gray-200">
        <div className="h-4 w-56 bg-gray-200 rounded mb-4" />
        <div className="h-72 bg-gray-100 rounded" />
      </div>

      {/* Breakdown chart */}
      <div className="bg-white rounded-lg shadow p-5 border border-gray-200">
        <div className="h-4 w-64 bg-gray-200 rounded mb-4" />
        <div className="h-64 bg-gray-100 rounded" />
      </div>

      {/* Projects table */}
      <div className="bg-white rounded-lg shadow p-4 md:p-5 border border-gray-200">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4">
          <div className="h-4 w-44 bg-gray-200 rounded" />
          <div className="flex gap-2">
            <div className="h-9 w-28 bg-gray-200 rounded-md" />
            <div className="h-9 w-36 bg-gray-200 rounded-md" />
          </div>
        </div>
        <TableSkeleton rows={5} columns={8} />
      </div>
    </div>
  );
}
